export const useMessage = (message) => {
	return {
		notify(type, title) {
			return ElNotification({
				type: type || 'info', 
				title: title || '信息提示', 
				message
			})
		},
		
		show(type) {
			return ElMessage({
			    showClose: true,
			    message,
			    type: type || 'info',
			  })
		},
		
		alert(type, title, opts) {
			return ElMessageBox.alert(message, title || '提示', Object.assign({
			    confirmButtonText: '确定',
				draggable: true
			}, opts || {}))
		},
		
		confirm(type, title, opts) {
			return ElMessageBox.confirm(message, title || '确认', Object.assign({
			    confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: type || 'info',
				draggable: true
			}, opts || {})).catch(() => { })
		},
		
		prompt(type, title, opts) {
			return ElMessageBox.prompt(message, title || '输入', Object.assign({
			    confirmButtonText: '确定',
				cancelButtonText: '取消',
				draggable: true
			}, opts || {})).catch(() => { })
		}
	}
}